var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxLockLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wxzhnhwgka)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#777E91"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 9.168a61.28 61.28 0 0 0-3.868.122 1.985 1.985 0 0 0-1.877 1.855 31.02 31.02 0 0 0-.088 2.19c0 .71.036 1.468.088 2.188a1.985 1.985 0 0 0 1.877 1.856 61.23 61.23 0 0 0 7.736 0 1.985 1.985 0 0 0 1.877-1.856c.052-.72.088-1.479.088-2.189s-.036-1.469-.088-2.189a1.985 1.985 0 0 0-1.877-1.855A61.276 61.276 0 0 0 10 9.168zM6.026 7.626a3.651 3.651 0 0 0-3.433 3.399 32.662 32.662 0 0 0-.093 2.31c0 .762.039 1.563.093 2.309a3.651 3.651 0 0 0 3.433 3.398 62.998 62.998 0 0 0 7.948 0 3.651 3.651 0 0 0 3.433-3.398c.054-.746.093-1.547.093-2.31 0-.762-.039-1.563-.093-2.309a3.651 3.651 0 0 0-3.433-3.399 62.951 62.951 0 0 0-7.948 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.833 13.945a1.666 1.666 0 1 0-1.666 0V15a.833.833 0 0 0 1.666 0v-1.056zM5.833 5a4.167 4.167 0 1 1 8.334 0v3.334a.833.833 0 1 1-1.667 0V5.001a2.5 2.5 0 1 0-5 0v3.333a.833.833 0 0 1-1.667 0V5.001z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "wxzhnhwgka"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .001)",
    d: "M0 0h20v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxLockLine);
export default __webpack_public_path__ + "static/media/bx-lock-line.b3056425e81140c14446fcd85a0f3e70.svg";
export { ForwardRef as ReactComponent };